/**
 * Link from a closed annual-report (renew) page to reinstatement for the same company. The renew page's d= token is
 * accepted by the reinstatement page as-is; without one, the visitor gets the reinstatement lookup.
 */
export function reinstateLinkFor(search: string): string {
    const token = new URLSearchParams(search).get('d')?.trim();

    return token ? `/reinstate?${new URLSearchParams({d: token, src: 'renew'}).toString()}` : '/reinstate';
}
